import React, { useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import {
  TwoColumnSection,
  LeftColumn,
  WhoWeAre,
  ConsultingText,
  RightColumn,
  DescriptionText
} from "./TwoColumnStyles";

const fadeInLeft = {
  hidden: { opacity: 0, x: -30 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

const fadeInRight = {
  hidden: { opacity: 0, x: 30 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

export default function TwoColumn() {
  const twoColumnRef = useRef(null);
  const twoColumnControls = useAnimation();
  const twoColumnInView = useInView(twoColumnRef, { once: true });

  React.useEffect(() => {
    if (twoColumnInView) twoColumnControls.start("visible");
  }, [twoColumnInView, twoColumnControls]);

  return (
    <TwoColumnSection ref={twoColumnRef}>
      <motion.div
        initial="hidden"
        animate={twoColumnControls}
        variants={fadeInLeft}
      >
        <LeftColumn>
          <WhoWeAre>Who are we</WhoWeAre>
          <ConsultingText>Expert consulting tailored to your business success</ConsultingText>
        </LeftColumn>
      </motion.div>
      
      <motion.div
        initial="hidden"
        animate={twoColumnControls}
        variants={fadeInRight}
      >
        <RightColumn>
          <DescriptionText>
            <p>
              August Twenty is a consultancy firm specialising in providing solutions –{' '}
              <em>Solution as a Service</em>. We believe all businesses deserve solutions
              that deliver for them and their clients.
            </p>
            
            <p>
              Our capabilities extend from the delivery of large complex global business solutions in information technology to providing pain free support for our clients in complex emerging markets.
            </p>
          </DescriptionText>
        </RightColumn>
      </motion.div>
    </TwoColumnSection>
  );
}